<template>
  <span>
    <a role="button" class="k-button k-button-icontext filter-clear" href="#" @click="buttonClick">
      <span class="k-icon k-i-plus"></span>
      Use in store
    </a>
  </span>
</template>

<script>
export default {
  name: "register",
  methods: {
    buttonClick: function (e) {
      e.preventDefault();
      this.templateArgs();
    }
  },
  data() {
    return {
      templateArgs: function(){}
    };
  }
};
</script>